import {
  axiosInstanceGeneralConfig,
  axiosAuthInstance,
  axiosAuthInstancePQR,
  axiosInstanceMyBodytech,
  axiosInstanceProducts,
} from "./instance";

export const getAllGenres = () => {
  return axiosInstanceGeneralConfig.get(`/genre/all`);
};

export const getAllCountries = () => {
  return axiosInstanceGeneralConfig.get(`/country/all`);
};

export const getAllCities = () => {
  return axiosInstanceGeneralConfig.get(`/city/all`);
};

export const getAllTrainingGoals = () => {
  return axiosInstanceGeneralConfig.get(`/trainingGoals`);
};

export const getAllOrigins = () => {
  return axiosInstanceGeneralConfig.get(`/origins`);
};

export const createCmsLead = (data) => {
  return axiosInstanceGeneralConfig.post("/crm-leads/add", data);
};

export const createAndUpdate = (data) => {
  return axiosInstanceMyBodytech.post("/users/create-or-update-user", data);
};

export const getAssessorByVenue = (venue) => {
  return axiosInstanceProducts.get(`/employees/venueafiliate/${venue}`);
};

export const validateExistsCmsLead = (data) => {
  return axiosInstanceGeneralConfig.post("/crm-leads/validateExists", data);
};

export const getCitiesByCountry = (countryId) => {
  return axiosAuthInstancePQR.get(`/listByCountry/${countryId}`);
};

export const getUserByDocument = (docType, doc) => {
  return axiosInstanceProducts.get(`/afiliates/document?type_document=${docType}&document=${doc}`);
};

export const createCoutesie = (body, user_type = 'lead') => {
  return axiosInstanceProducts.post(`courtesies/add?type=${user_type}`, body);
};

export const resendCode = (body) => {
  return axiosInstanceMyBodytech.post("/users/resend-double-autentication-code", body);
};

export const doubleAuthenticationCodeValidation = (body) => {
  return axiosInstanceMyBodytech.post("/users/double-authentication-code-validation", body);
};
